export const authors = [
    {
        id: 1,
        name: "Nizar Qabbani",
        image: "/authors/nizar.jpg",
    },
    {
        id: 2,
        name: "Mahmoud Darwish",
        image: "/authors/darwish.jpg",
    },
    {
        id: 3,
        name: "Tony Robbins",
        image: "/authors/tony.jpg",
    },
    {
        id: 4,
        name: "Elif Shafak",
        image: "/authors/shafak.jpg",
    },
    {
        id:5,
        name: "Brian Tracy",
        image: "/authors/brain.jpg",
    },
    {
        id:6,
        name: "Nassim Nicholas Taleb",
        image: "/authors/nassim.jpg",
    },
    {
        id: 7,
        name: "Khalil Gibran",
        image: "/authors/khalil.jpg",
    },
    {
        id: 8,
        name: "Debbie Ford",
        image: "/authors/ford.jpg",
    },
    {
        id: 9,
        name: "Paulo Coelho",
        image: "/authors/paulo.jpg",
    },
    {
        id: 10,
        name: "Wayne Dyer",
        image: "/authors/wayne.jpg",
    },
    {
        id:11,
        name: "Albert Camus",
        image: "/authors/albert.jpg",
    },
    {
        id:12,
        name: "George Orwell",
        image: "/authors/george.jpg",
    },
    {
        id: 13,
        name: "Robert Kiyosaki",
        image: "/authors/kiyosaki.jpg",
    },
    {
        id: 14,
        name: "Warren Buffett",
        image: "/authors/buffett.jpg",
    },
    {
        id: 15,
        name: "Ernest Hemingway",
        image: "/authors/eh.jpg",
    },
    {
        id: 16,
        name: "Mark Twain",
        image: "/authors/mark.jpg",
    },
    {
        id:17,
        name: "Xavier Crement",
        image: "/authors/crement.jpg",
    },
    {
        id:18,
        name: "Rolf Dobelli",
        image: "/authors/rolf.jpg",
    },
    {
        id: 19,
        name: "George Samuel Clason",
        image: "/authors/clason.jpg",
    },
    {
        id: 20,
        name: "Phil Knight",
        image: "/authors/phil.jpg",
    },
    {
        id: 21,
        name: "Oscar Wilde",
        image: "/authors/oscar.jpg",
    },
    {
        id: 22,
        name: "James Clear",
        image: "/authors/james.jpg",
    },
    {
        id:23,
        name: "Colleen Hoover",
        image: "/authors/hoover.jpg",
    },
    {
        id:24,
        name: "Sajni Patel",
        image: "/authors/patel.jpg",
    },
    {
        id:25,
        name: "Taylor Jenkins Reid",
        image: "/authors/reid.jpg",
    },
    {
        id:26,
        name: "Napolen Hill",
        image: "/authors/hill.jpg",
    },
    {
        id:27,
        name: "Chris Voss",
        image: "/authors/voss.jpg",
    },
    {
        id:28,
        name: "Vex King",
        image: "/authors/king.jpg",
    },
    {
        id:29,
        name: "Juliette Aristides",
        image:"/authors/j.jpg",
    },
    {
        id:30,
        name:"Leo Tolstoy",
        image:"/authors/leo.jpg"
    }
].sort((a, b) => (a.name > b.name ? 1 : -1));